import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface BookingConfirmationDetailTextProps {
  text: string;
}

const BookingConfirmationDetailText = ({
  text
}: BookingConfirmationDetailTextProps) => (
  <Box>
    <Typography fontSize="18px">{text}</Typography>
  </Box>
);

export default BookingConfirmationDetailText;
